export default __webpack_public_path__ + "static/media/white_forward_arrow.20f8ff01.svg";